import { TaxModel } from "../management/tax.model";

export class InvoiceCashReceiptRetentionModel {
  invoiceCashReceiptRetentionId: number = 0;
  invoiceCashReceiptId: number = 0;
  taxId: number = 0;
  tax: TaxModel = new TaxModel();
  rate: number = 0;
  base: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}